import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { stringStep } from '../../../concepts/commands/CommandWizard';
import { alert } from '../../packages/alerts/AlertCommands';
import { dumpPopup } from '../../popups/DumpPopup';
import { PopupManager } from '../../popups/PopupManager';
import { KioskController } from './KioskController';
import { Recordings } from './recordings/Recordings';

export const kioskStartRecording = defineCommand(
    'kioskStartRecording',
    'Kiosk: Start Recording',
    r => {
        r.call(KioskController).startRecording();
    }
);

export const kioskStopRecording = defineCommand(
    'kioskStopRecording',
    'Kiosk: Stop Recording',
    r => {
        const data = r.call(KioskController).stopRecording();
        r.call(PopupManager).invoke(dumpPopup({
            dump: JSON.stringify(data, null, 4)
        }));
    }
);

export const kioskToggleRecording = defineCommand(
    'kioskToggleRecording',
    'Kiosk: Toggle Recording',
    r => {
        const data = r.call(KioskController).stopRecording();
        if (!!data.length) {
            r.call(PopupManager).invoke(dumpPopup({
                dump: JSON.stringify(data, null, 4)
            }));
        }
        else {
            r.call(CommandDispatcher)(alert, ['Recording']);
            r.call(KioskController).startRecording();
        }
    }
);

export const kioskPlayRecording = defineCommand(
    'kioskPlayRecording',
    'Kiosk: Play Recording',
    async (r, [name, replacements]: [string, Record<string, string>?]) => {
        const ctrl = r.call(KioskController);

        const actor = await ctrl.getOrCreateActor(replacements?.hasOwnProperty('$USER') ? replacements.$USER : null);
        const baseRec = Recordings[name];

        const recString = { str: JSON.stringify(baseRec) };
        for (const key in replacements) {
            if (replacements.hasOwnProperty(key)) {
                recString.str = recString.str.replaceAll(`${key}`, replacements[key]);
            }
        };

        if (!replacements?.hasOwnProperty('$USER')) {
            recString.str = recString.str.replaceAll('$USER', actor.user.id);
        };

        const userRec = JSON.parse(recString.str);

        actor.replay(userRec);
    },
    [
        stringStep('name', 'Name:'),
    ]
);
